export const isIMO = (value: number) => {
  return Number.isInteger(value) && value.toString().length === 7
}
